import { Component, OnInit, OnDestroy, ViewChild, ElementRef, AfterViewChecked } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ChatBotService, ChatMessage, ChatSession } from '../../services/chat-bot.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-chat-bot',
    imports: [CommonModule, FormsModule, TranslateModule],
    templateUrl: './chat-bot.component.html',
    styleUrls: ['./chat-bot.component.scss']
})
export class ChatBotComponent implements OnInit, OnDestroy, AfterViewChecked {
  @ViewChild('messagesContainer') messagesContainer!: ElementRef;
  @ViewChild('messageInput') messageInput!: ElementRef;

  isOpen = false;
  isMinimized = false;
  currentMessage = '';
  session: ChatSession | null = null;
  isTyping = false;
  
  private subscriptions = new Subscription();

  constructor(private chatBotService: ChatBotService) {}

  ngOnInit(): void {
    // Forcer l'affichage de la bulle
    console.log('ChatBot component initialized');
    
    // S'abonner à la session courante
    this.subscriptions.add(
      this.chatBotService.currentSession$.subscribe(session => {
        this.session = session;
        console.log('Session updated:', session);
      })
    );

    // S'abonner à l'état de frappe
    this.subscriptions.add(
      this.chatBotService.isTyping$.subscribe(typing => {
        this.isTyping = typing;
      })
    );
  }

  ngAfterViewChecked(): void {
    this.scrollToBottom();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  toggleChat(): void {
    this.isOpen = !this.isOpen;
    if (this.isOpen) {
      this.isMinimized = false;
      // Focus sur l'input après ouverture
      setTimeout(() => {
        if (this.messageInput) {
          this.messageInput.nativeElement.focus();
        }
      }, 100);
    }
  }

  minimizeChat(): void {
    this.isMinimized = true;
  }

  maximizeChat(): void {
    this.isMinimized = false;
  }

  closeChat(): void {
    this.isOpen = false;
    this.isMinimized = false;
  }

  sendMessage(): void {
    if (!this.currentMessage.trim()) return;

    const message = this.currentMessage.trim();
    this.currentMessage = '';

    this.chatBotService.sendMessage(message).subscribe(response => {
      // La réponse est déjà ajoutée à la session par le service
    });
  }

  sendQuickReply(option: string): void {
    this.currentMessage = option;
    this.sendMessage();
  }

  onKeyPress(event: KeyboardEvent): void {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      this.sendMessage();
    }
  }

  private sendWelcomeMessage(): void {
    this.chatBotService.sendMessage('bonjour').subscribe();
  }

  private scrollToBottom(): void {
    if (this.messagesContainer) {
      const element = this.messagesContainer.nativeElement;
      element.scrollTop = element.scrollHeight;
    }
  }

  clearChat(): void {
    this.chatBotService.clearSession();
  }

  // Méthodes utilitaires pour l'affichage
  formatTime(date: Date): string {
    return new Intl.DateTimeFormat('fr-FR', {
      hour: '2-digit',
      minute: '2-digit'
    }).format(date);
  }

  getMessageClasses(message: ChatMessage): string {
    return `message ${message.isBot ? 'bot-message' : 'user-message'}`;
  }
}
